module.exports = __webpack_public_path__ + "assets/img/98cb22c64268f5c5e2bc8b00c09b8ee3.png";